import React, { useState, useEffect, useCallback, useRef } from "react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { useOrganization } from "../../configurations/OrganizationContext";

import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import { Search, PublishedWithChanges } from "@mui/icons-material";
import { PRINT_FILE, PRINT_PREVIEW } from "../../shared/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  doctorActions,
  ehrActions,
  labActions,
  patientActions,
} from "../../core/actions";
import {
  EPRESCRIPTION,
  PRODUCT_PHARMACY_LOCATION,
} from "../../shared/constants";
import Components from "..";
import { jsonSchema } from "../../shared/schema";
import debounce from "lodash.debounce";
import TextField from "@mui/material/TextField";
import {
  Tabs,
  Tab,
  Fab,
  Container,
  MenuItem,
  Select,
  Autocomplete,
} from "@mui/material";

import { IconButton } from "@mui/material";
import { Add } from "@mui/icons-material";
import ReplayIcon from "@mui/icons-material/Replay";
import { Tooltip } from "@mui/material";

import { MASTER_LOCATION_DATA_LOCATION_KEY } from "../../core/constants/erpConstants";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import { helperServices } from "../../shared/helper";
function Prescription(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const dispatch = useDispatch();
  const [productList, setProductList] = useState([]);
  const consumptionOptions = [
    "0-0-0-0",
    "0-0-0-1",
    "0-0-1-0",
    "0-0-1-1",
    "0-1-0-0",
    "0-1-0-1",
    "0-1-1-0",
    "0-1-1-1",
    "1-0-0-0",
    "1-0-0-1",
    "1-0-1-0",
    "1-0-1-1",
    "1-1-0-0",
    "1-1-0-1",
    "1-1-1-0",
    "1-1-1-1",
  ];
  const [presData, setPresData] = useState([]);
  const org = useOrganization();
  const [dataDrop, setDataDrop] = useState(consumptionOptions.slice());
  const [selectedData, setSelectedData] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);
  const [focusedInputId, setFocusedInputId] = useState(null);
  const [formschema, setFormschema] = useState(false);
  const [schemajson, setSchemajson] = useState();
  const [patientId, setPatientId] = useState();
  const [visitId, setVisitId] = useState();
  const [isReadonly, setIsReadonly] = useState(false);
  const patientEhrid = useSelector((state) => state.patientDetailsState.ehrid);
  const [showpdfscreen, setpdfscreen] = useState(false);
  const [print, setPrint] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [printPrescriptionList, setPrintPrescriptionList] = useState([]);
  const [getLastVisitId, setGetLastVisitId] = useState(false);
  const [getVisitId, setGetVisitId] = useState(0);
  const [getCurrentVisitId, setGetCurrentVisitId] = useState(0);
  const [procedureList, setProcedureList] = useState([]);
  const [removedProcedureIds, setRemovedProcedureIds] = useState([]);
  const [removedPrescriptionItems, setRemovedPrescriptionItems] = useState([]);
  const [compositionPreviewValue, setCompositionPreviewValue] = useState({
    brandName: "",
    icdName: "",
  });
  const [isSaving, setIsSaving] = useState(false);
  const [eprescription, seteprescription] = useState();
  const [hideResults, setHideResults] = useState(false);
  const [printPreviewType, setPrintPreviewType] = useState("");
  var count = 0;
  const allVisitdates = useSelector(
    (state) => state.patientDetailsState.patientBasic,
  );
  const modifyNotes = {
    localMedicalBrand: "",
    instructionstoPatient: "",
    advicetoDispenser: "",
    comments: "",
    problemDiagnosis: "",
    dose: "",
  };

  //suggestions changes
  const [hideDropdown, setHideDropdown] = useState(false);
  const [selectedresult, setSelectedresult] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [clonepresclicked, setClonepresclicked] = useState(false);
  const searchInputRef = useRef(null);

  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails,
  );

  // const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    setPatientId(props.patientId);
    setVisitId(props.visitId);
    let patId = props.patientId;
    let vid;
    for (let i = 0; i < allVisitdates.visitList.length; i++) {
      let visit = allVisitdates.visitList[i];
      console.log("allVisitdates", visit);
      if (visit.status == "close") {
        console.log("visit.id", visit.id);
        vid = visit.id;
        setGetVisitId(visit.id);
      }
    }
    for (let i = 0; i < allVisitdates.visitList.length; i++) {
      let visit = allVisitdates.visitList[i];
      console.log("allVisitdates", visit);
      if (visit.status == "open") {
        console.log("visit.id", visit.id);
        vid = visit.id;
        setGetCurrentVisitId(visit.id);
      }
    }
    if (vid !== 0) {
      console.log("visitId", vid);
      // getProcedureListPresc(patId, vid, props.visitId);
      // fetchSuggestions();
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }
    getTemplateById();
    console.log("props in pres: ", props, props.data);
    console.log("VisitDate", allVisitdates);
    console.log("setGetLAstVisitId", getLastVisitId);
  }, []);

  const getProcedureListPresc = (
    patientId,
    lastVisitId,
    curVisitId,
    status,
  ) => {
    let type = "showAllVisits";
    dispatch(
      patientActions.getPatientProcedureInfo(
        patientId,
        lastVisitId,
        type,
        (resCb) => {
          if (resCb?.patientresp?.procedureslist) {
            console.log("rescpProcedure", resCb);
            const prescriptions = resCb.patientresp.procedureslist.filter(
              (procedure) =>
                procedure.templateId === EPRESCRIPTION &&
                procedure.markForDel !== true,
            );

            setProcedureList(prescriptions);
            setFilteredList(status === "old" ? prescriptions : []);
            if (prescriptions.length > 0) {
              getLastPrescriptionList(prescriptions, status);
              return true;
            } else {
              return false;
            }
          }
        },
      ),
    );

    console.log("procedureList", procedureList);
  };

  const getLastPrescriptionList = (procedures, status) => {
    for (let i = 0; i < procedures.length; i++) {
      const procedure = procedures[i];

      // Non-EHR organizations persist the complete canonical prescription in
      // procedure.notes. Reading it here also avoids dropping a prescription
      // when there is no compositionId in that flow.
      try {
        const notes =
          typeof procedure.notes === "string"
            ? JSON.parse(procedure.notes)
            : procedure.notes;
        const items = notes?.content?.[0]?.activities?.[0]?.description?.items;
        if (Array.isArray(items)) {
          addPrescToSelectData(items, status, procedure.id);
          continue;
        }
      } catch (error) {
        console.warn("Could not read prescription from procedure notes", error);
      }

      if (!procedure.compositionId) continue;

      let templateData = procedure.compositionId;
      let data = {};
      let flags = "editComposition";
      dispatch(
        ehrActions.getCompositionByVid(
          data,
          templateData,
          patientEhrid,
          async (resCb) => {
            if (resCb) {
              console.log("eee", resCb);
              let val = [];
              val = resCb.content[0].activities[0].description.items;
              addPrescToSelectData(val, status, procedure.id);
              setPresData(val);
              let form = await jsonSchema.getSchemaFromCanonicalJson(
                resCb,
                procedure.templateId,
                flags,
                compositionPreviewValue,
              );
              setCompositionPreviewValue(compositionPreviewValue);
              console.log(
                "form, compositionpreviewvalue: ",
                form,
                compositionPreviewValue,
              );
              let frm = await jsonSchema.getSchemaFromCanonicalJson(
                resCb,
                procedure.templateId,
                "editComposition",
              );
              console.log("frm ::: ", frm, presData);
              seteprescription(frm);
            }
          },
        ),
      );
    }
  };

  const addPrescToSelectData = (data, status, procedureId) => {
    let dose = "";
    let consumption = "";
    let advice = "";
    let comments = "";
    let text = "";
    let id = "";
    let productsearch = "";
    if (data) {
      console.log("prescription data : ", data);
      let val = [];
      val = data;
      for (let items of val) {
        console.log("itms", items);
        if (items._type == "CLUSTER") {
          for (let item of items.items) {
            if (item._type === "CLUSTER") {
              for (let i of item.items) {
                console.log("i: ", i);
                console.log("item value : ", i.name.value, i.value.value);
                dose = i.value.value;
              }
            } else {
              advice = item.value.value;
              console.log(
                "data of advice to dispencer after",
                item.value.value,
              );
            }
          }
        }
        if (items._type == "ELEMENT") {
          console.log("element is", items._type);
          if (items.name.value == "Local medicinal product brand") {
            console.log("item value : ", items.value.value);
            text = items.value.value;
          } else if (items.name.value == "Instructions to patient") {
            consumption = items.value.value;
            console.log("data: ", items.value.value);
          } else {
            comments = items.value.value;
            console.log("data: ", items.value.value);
          }
        }
      }
      productsearch = text || "dol";
      const pharmacyLocationId = helperServices.getFirstLocationIdByKey(
        masterLocationDetails,
        MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY,
      );
      dispatch(
        doctorActions.getProductDetails(
          productsearch,
          pharmacyLocationId,
          (productResponse) => {
            if (productResponse?.erpProductList?.length > 0) {
              id = productResponse.erpProductList[0].productId;
              handleAdd(
                {
                  id,
                  text,
                  dose,
                  consumption,
                  advice,
                  comments,
                },
                status,
                procedureId,
              );
            }
          },
        ),
      );
    }
  };

  // to get schema and get the prescription data in edit case
  const getTemplateById = () => {
    console.log("prescription method call in use effect");
    let data = "";
    console.log("LastVisitDate", getLastVisitId);
    console.log("resCb present");
    let dose = "";
    let consumption = "";
    let advice = "";
    let comments = "";
    let text = "";
    let id = "";
    if (props.data) {
      console.log("prescription data : ", props.data);
      let val = [];
      val = props.data;
      for (let items of val) {
        console.log("itms", items);
        if (items._type == "CLUSTER") {
          for (let item of items.items) {
            if (item._type === "CLUSTER") {
              for (let i of item.items) {
                console.log("i: ", i);
                console.log("item value : ", i.name.value, i.value.value);
                dose = i.value.value;
              }
            } else {
              advice = item.value.value;
              console.log(
                "data of advice to dispencer after",
                item.value.value,
              );
            }
          }
        }
        if (items._type == "ELEMENT") {
          console.log("element is", items._type);
          if (items.name.value == "Local medicinal product brand") {
            console.log("item value : ", items.value.value);
            text = items.value.value;
          } else if (items.name.value == "Instructions to patient") {
            consumption = items.value.value;
            console.log("data: ", items.value.value);
          } else {
            comments = items.value.value;
            console.log("data: ", items.value.value);
          }
        }
      }
      console.log("onformchangeschemajson", val);

      console.log("modifynote : ", modifyNotes);
    }
    let patient = {};

    const pharmacyLocationId = helperServices.getFirstLocationIdByKey(
      masterLocationDetails,
      MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY,
    );

    dispatch(
      ehrActions.getTemplateById(data, EPRESCRIPTION, patient, (resCb) => {
        console.log("resCb check", resCb);
        if (resCb) {
          // The prescription schema is returned by getTemplateById. Keep it
          // independently of the pharmacy product lookup so Save cannot race
          // with (or depend on) that second request.
          setSchemajson(resCb);
          let productsearch = "";
          if (text == "") {
            productsearch = "dol";
          } else {
            productsearch = text;
          }
          dispatch(
            doctorActions.getProductDetails(
              productsearch,
              pharmacyLocationId,
              (productResponse) => {
                console.log("productResponse check");
                if (productResponse) {
                  console.log("productResponse present", productResponse);
                  console.log(
                    "Response of searched product",
                    productResponse.erpProductList,
                  );
                  if (productResponse.erpProductList?.length > 0) {
                    const productList = productResponse.erpProductList;
                    console.log("product List : ", productList);
                    console.log("value ::: ", productList[0].productId);
                    id = productList[0].productId;
                    console.log("id : ", id);
                    const newData = {
                      id: id,
                      text: text,
                      dose: dose,
                      consumption: consumption,
                      advice: advice,
                      comments: comments,
                      status: "new",
                    };

                    const newKey = newData.id.toString();
                    if (props.mode == "edit") {
                      setSearchResults((prevData) => {
                        return [{ ...newData, key: newKey }];
                      });

                      setIsReadonly(true);
                    }
                  }
                  console.log("schema is ", resCb, searchResults);
                  console.log("schema data: ", resCb);
                  console.log("formschema1", formschema);
                }
              },
            ),
          );
        }
      }),
    );
    console.log(" data get : ", dose, advice, consumption, comments, text, id);
  };

  // method called when the tab is changed
  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
    setSearchResults([]);
    // setSelectedData('');
    setSearchQuery("");
    setShowDropdown(false);
  };

  // method to search on keypress
  const handleSearchInputChange = (event) => {
    const inputValue = event.target.value;
    setSearchQuery(inputValue);
    console.log("inputValue ", inputValue);
    console.log("inputValue length", inputValue.length);
    setShowDropdown(false);
    if (inputValue && inputValue.length > 1) {
      // setSearchQuery(inputValue);
      setProductList([]);
      // searchPharmacyProducts(inputValue);
      // setSearchResults([]);
      // setHideResults(false);
      setHideDropdown(false);
      debounceSearchProducts(inputValue);
    } else {
      setHideResults(true);
      setHideDropdown(true);
      console.log("inputValue length", searchResults);
      setSearchQuery(inputValue);
      setSearchResults([]);
    }
  };

  const searchPharmacyProducts = (inputValue) => {
    const pharmacyLocationId = helperServices.getFirstLocationIdByKey(
      masterLocationDetails,
      MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY,
    );
    console.log("data : ", productList, inputValue);
    dispatch(
      doctorActions.getProductDetails(
        inputValue,
        pharmacyLocationId,
        (resCb) => {
          if (resCb) {
            let results = [];
            console.log("Response of searched product", resCb.erpProductList);
            console.log("schema is ", resCb);
            console.log("form obtained:", resCb.erpProductList);
            if (hideResults != true && Array.isArray(resCb.erpProductList)) {
              resCb.erpProductList.forEach((element) => {
                if (
                  !productList.some((item) => item.id === element.productId)
                ) {
                  const newData = {
                    id: parseInt(element.productId),
                    text: element.productName || "",
                    dose: "",
                    consumption: "",
                    advice: "",
                    comments: "",
                    durationUnit: "days",
                  };

                  const newKey = newData.id.toString();
                  results.push(newData);
                  productList.push(newData);
                  // setProductList((prevData) => {
                  //   if (!prevData.some((item) => item.id === newData.id)) {
                  //     return [...prevData, { ...newData, key: newKey }];
                  //   }
                  //   return prevData;
                  // });
                }
              });
              handleSearch(inputValue, results);
              console.log("data : ", productList, inputValue, results);
            }
          }
        },
      ),
    );
  };

  const debounceSearchProducts = useCallback(
    debounce(searchPharmacyProducts, 500),
    [],
  );

  // method to search
  const handleSearch = (inputValue, prodresult) => {
    console.log(
      "data ::: ",
      "inputValue:",
      inputValue,
      "searchquery: ",
      searchQuery,
    );
    if (searchQuery.trim() === "") {
      if (inputValue != "") {
        console.log("data ::: ", prodresult);
        const results = prodresult.filter((item) =>
          item.text.toLowerCase().includes(searchQuery.toLowerCase()),
        );
        // setSearchResults(results);
        setSelectedresult(results);
      } else {
        // setSearchResults([]);
        setSelectedresult([]);
        console.log("data ::: ", productList);
      }
    } else {
      console.log("data ::: ", productList);
      const results = prodresult.filter((item) =>
        item.text.toLowerCase().includes(searchQuery.toLowerCase()),
      );
      // setSearchResults(results);
      setSelectedresult(results);
      console.log("data ::: ", results, searchResults);
    }
  };

  // method to add or update prescription
  const handleAdd = (result, status, procedureId) => {
    console.log("result in prescriptionjs for add", selectedData);
    setSelectedData((prev) => {
      const allFieldsEmpty =
        !result.dose &&
        !result.consumption &&
        !result.advice &&
        !result.comments;

      if (allFieldsEmpty && status !== "old") {
        return prev;
      }
      console.log("results in prescrioptionjs for add", result);
      const existingIndex = prev.findIndex((item) =>
        status === "old"
          ? item?.procedureId?.value === procedureId
          : item.id === result.id,
      );

      if (existingIndex !== -1) {
        // Update existing item
        return prev.map((item) =>
          item.id === result.id
            ? {
              ...item,
              dose: {
                ...item.dose,
                value: result.dose ?? item.dose.value,
              },
              consumption: {
                ...item.consumption,
                value: result.consumption ?? item.consumption.value,
              },
              advice: {
                ...item.advice,
                value: result.advice ?? item.advice.value,
              },
              durationUnit: {
                ...item.durationUnit,
                value: result.durationUnit ?? item.durationUnit?.value ?? "days",
              },
              comments: {
                ...item.comments,
                value: result.comments ?? item.comments.value,
              },
              procedureId: {
                label: "ProcedureID",
                value: procedureId || item?.procedureId?.value,
              },
            }
            : item,
        );
      } else {
        if (status == "old") {
          // Add new item at beginning
          const newData = {
            id: result.id,
            text: result.text,
            dose: { label: "Weightage", value: result.dose },
            consumption: { label: "Consumption", value: result.consumption },
            advice: { label: "Advice", value: result.advice },
            durationUnit: { label: "Duration Unit", value: result.durationUnit || "days" },
            comments: { label: "Comments", value: result.comments },
            status: { label: "Status", value: "old" },
            procedureId: { label: "ProcedureID", value: procedureId },
          };
          console.log("newData : ", newData);
          return [newData, ...prev];
        } else {
          const newData = {
            id: result.id,
            text: result.text,
            dose: { label: "Weightage", value: result.dose },
            consumption: { label: "Consumption", value: result.consumption },
            advice: { label: "Advice", value: result.advice },
            durationUnit: { label: "Duration Unit", value: result.durationUnit || "days" },
            comments: { label: "Comments", value: result.comments },
          };
          console.log("newData : ", newData);
          return [newData, ...prev];
        }
      }
    });

    // Reset UI state
    setShowDropdown(false);
    if (searchInputRef.current) {
      searchInputRef.current.focus();
      setSearchQuery("");
      setSearchResults([]);
    }

    // Reset search result item
    setSearchResults((prev) =>
      prev.map((item) =>
        item.id === result.id
          ? { ...item, dose: "", consumption: "", advice: "", comments: "", durationUnit: "days" }
          : item,
      ),
    );
  };

  // method to remove selected prescription
  const handleCancel = (index) => {
    const removedPrescription = selectedData[index];
    const removedProcedureId = removedPrescription?.procedureId?.value;
    if (
      removedPrescription?.status?.value === "old" &&
      removedProcedureId
    ) {
      const savedProcedure = filteredList.find(
        (procedure) => String(procedure.id) === String(removedProcedureId),
      );
      const productId = savedProcedure?.productId;
      const units = Number(savedProcedure?.quantity);
      setRemovedProcedureIds((prev) =>
        prev.includes(removedProcedureId)
          ? prev
          : [...prev, removedProcedureId],
      );
      if (productId && Number.isFinite(units) && units > 0) {
        setRemovedPrescriptionItems((prev) =>
          prev.some((item) => item.procedureId === removedProcedureId)
            ? prev
            : [
              ...prev,
              {
                procedureId: removedProcedureId,
                product: String(productId),
                units,
              },
            ],
        );
      } else {
        console.warn(
          "ERP prescription delete skipped: product ID or quantity is missing for procedure",
          removedProcedureId,
        );
      }
    }

    const updatedSelectedData = [...selectedData];
    updatedSelectedData.splice(index, 1);
    setSelectedData(updatedSelectedData);
    console.log("updatedSelectedData : ", updatedSelectedData, filteredList);
    let ehrdata = filteredList.filter((item) =>
      updatedSelectedData.some((proc) => proc?.procedureId?.value == item.id),
    );
    console.log("ehrdata : ", ehrdata);

    setFilteredList(ehrdata);
  };

  // method to handle consumption dropdown select
  const handleOptionSelect = (option, id) => {
    console.log("option : ", option, id);
    setSearchResults((prevResults) =>
      prevResults.map((prevResult) =>
        prevResult.id === id
          ? { ...prevResult, consumption: option }
          : prevResult,
      ),
    );

    setShowDropdown(false);
  };

  // method to handle consumption dropdown select
  const handleOptionPresc = (option, id) => {
    console.log("option : ", option);
    setSearchResults((prevResults) =>
      prevResults.map((prevResult) => ({
        ...prevResult,
        consumption: option,
      })),
    );
    setShowDropdown(false);
  };

  // method to handle consumption dropdown select
  //   const handleOptionSelect = (option) => {
  //     console.log("option : ", option);
  //     setSearchResults((prevResults) =>
  //       prevResults.map((prevResult) => ({
  //         ...prevResult,
  //         consumption: option,
  //       }))
  //     );

  //     setShowDropdown(false);
  //   };

  //method to handle consumption dropdown arrow buttons navigation
  const handleKeyDown = (event, id) => {
    console.log("event.key : ", event.key, dataDrop);
    if (
      event.key === "ArrowDown" &&
      selectedOptionIndex < dataDrop.length - 1
    ) {
      setSelectedOptionIndex(selectedOptionIndex + 1);
    } else if (event.key === "ArrowUp" && selectedOptionIndex > 0) {
      setSelectedOptionIndex(selectedOptionIndex - 1);
    } else if (event.key === "Enter" && selectedOptionIndex !== -1) {
      console.log(
        "dataDrop[selectedOptionIndex] : ",
        dataDrop[selectedOptionIndex],
      );
      handleOptionSelect(dataDrop[selectedOptionIndex], id);
      setShowDropdown(false);
    }
    setFocusedInputId(id);
  };

  // method to auto fill data from selected prescription to the search result
  const handleSelectedItemClick = (selectedItem) => {
    console.log("selectedItemId : ", selectedItem.id, selectedItem);
    console.log("productList : ", productList);
    const results = productList.filter((item) => item.id == selectedItem.id);
    console.log("results : ", results);
    const newData = {
      id: selectedItem.id,
      text: selectedItem.text,
      dose: selectedItem.dose.value,
      consumption: selectedItem.consumption.value,
      advice: selectedItem.advice.value,
      durationUnit: selectedItem.durationUnit?.value || "days",
      comments: selectedItem.comments.value,
    };

    const newKey = newData.id.toString();

    setSearchResults((prevData) => {
      return [{ ...newData, key: newKey }];
    });
    console.log("SearchResults : ", searchResults);
    setSearchQuery("");
  };

  // method to handle changes done in dose field
  const handleDoseChange = (id, value) => {
    console.log("In handleinput change", id, value);
    setSearchResults((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, dose: value } : item,
      ),
    );
    console.log("data : ", productList);
  };

  // method to handle changes done in consumption field
  const handleConsumptionChange = (result, e) => {
    let value = e;
    console.log("DropDown Value", result, value);

    if (e.nativeEvent.inputType === "deleteContentBackward") {
      value = value.slice(0, -1);
    } else {
      value = value.replace(/[^0-1]/g, "");

      if (value.length > 1) {
        value = value.split("").join("-");
      }
      value = value.slice(0, 7);
    }

    setSearchResults((prevResults) =>
      prevResults.map((prevResult) =>
        prevResult.id === result.id
          ? { ...prevResult, consumption: value }
          : prevResult,
      ),
    );
    console.log("Drop down value", value, result.id);

    const userInput = value.toLowerCase();
    const filteredOptions = consumptionOptions.filter((option) =>
      option.toLowerCase().startsWith(userInput),
    );

    setDataDrop(filteredOptions);
    console.log("filteredOptions : ", filteredOptions);
    // Update showDropdown based on whether there are matching options
    setShowDropdown(userInput.length > 0 && filteredOptions.length > 0);

    setSelectedOptionIndex(-1);
    setFocusedInputId(result.id);
  };

  // method to handle changes done in consumption field
  const handleConsumptionChangePresc = (result, e) => {
    let value = e;
    console.log("DropDown Value", result, value);

    // if (e.nativeEvent.inputType === "deleteContentBackward") {
    //   value = value.slice(0, -1);
    // } else {
    //   value = value.replace(/[^0-1]/g, "");

    //   if (value.length > 1) {
    //     value = value.split("").join("-");
    //   }
    //   value = value.slice(0, 7);
    // }

    setSearchResults((prevResults) =>
      prevResults.map((prevResult) =>
        prevResult.id === result.id
          ? { ...prevResult, consumption: value }
          : prevResult,
      ),
    );
    console.log("Drop down value", value, result.id);

    const userInput = value?.toLowerCase() || "";
    const filteredOptions = consumptionOptions.filter((option) =>
      option.toLowerCase().startsWith(userInput),
    );

    setDataDrop(filteredOptions);
    console.log("filteredOptions : ", filteredOptions);
    // Update showDropdown based on whether there are matching options
    setShowDropdown(userInput.length > 0 && filteredOptions.length > 0);

    setSelectedOptionIndex(-1);
    setFocusedInputId(result.id);
  };

  // method to handle changes done in advise field
  const handleAdviceChange = (id, value) => {
    console.log("In handleAdviceChange ", id, value);
    setSearchResults((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, advice: value } : item,
      ),
    );
    console.log("data : ", productList);
  };

  const handleDurationUnitChange = (id, value) => {
    setSearchResults((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, durationUnit: value } : item,
      ),
    );
  };

  // method to handle changes done in comments field
  const handleCommentsChange = (id, value) => {
    console.log("In handleCommentsChange", id, value);
    setSearchResults((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, comments: value } : item,
      ),
    );
    console.log("data : ", productList);
  };

  // method to handle submit
  const handleSubmit = (flag) => {
    if (isSaving) return;

    const newPrescriptions = selectedData.filter(
      (prescription) => prescription?.status?.value !== "old",
    );

    if (
      newPrescriptions.length > 0 &&
      !Array.isArray(schemajson?.content)
    ) {
      console.error("Prescription schema is not ready:", schemajson);
      props.onModalClose({
        error: "Prescription form is still loading. Please try saving again.",
      });
      return;
    }

    setIsSaving(true);
    console.log("schema in sumbit : ", schemajson);
    console.log("data : ", patientId, visitId, patientEhrid, print);
    console.log("patientId,VisitId", patientId, visitId);

    const saveNewPrescriptions = () => {
      setPrint(true);
      console.log("Schema before saving:", JSON.stringify(schemajson, null, 2));
      onConvertSchematoJsonprescription(schemajson, flag);
    };

    if (removedProcedureIds.length === 0) {
      if (newPrescriptions.length > 0) {
        saveNewPrescriptions();
      } else {
        setIsSaving(false);
        if (flag) {
          const savedPrescriptions =
            filteredList.length > 0 ? filteredList : procedureList;
          if (savedPrescriptions.length === 0) {
            props.onModalClose({ error: "No prescription available to print" });
          } else {
            setPrintPrescriptionList([...savedPrescriptions]);
            setpdfscreen(true);
          }
        } else {
          props.onModalClose({ success: "No prescription changes to save" });
        }
      }
      return;
    }

    let completedDeletes = 0;
    let deleteError = "";
    removedProcedureIds.forEach((procedureId) => {
      const markForDel = {
        id: procedureId,
        patientId,
        visitId,
        markForDel: true,
      };
      console.log("markForDel", markForDel, removedProcedureIds);
      dispatch(
        patientActions.markForDel(markForDel, (resCb) => {
          console.log("deleted procedure Response ", resCb);
          completedDeletes += 1;
          if (typeof resCb === "string") {
            deleteError = resCb;
          } else if (resCb?.errorMessages?.length) {
            deleteError = resCb.errorMessages[0];
          }

          if (completedDeletes === removedProcedureIds.length) {
            if (deleteError) {
              setIsSaving(false);
              props.onModalClose({ error: deleteError });
            } else {
              const productList = removedPrescriptionItems.map((item) => ({
                product: item.product,
                units: item.units,
              }));
              const cartNo = String(allVisitdates?.phno ?? "").trim();
              if (cartNo && productList.length > 0) {
                dispatch(
                  ehrActions.deletePrescriptionFromErp(
                    { cartNo, productList },
                    (erpResponse) => {
                      if (erpResponse?.warningMessages?.length) {
                        console.warn(erpResponse.warningMessages[0]);
                      } else {
                        console.log("ERP prescription delete response:", erpResponse);
                      }
                    },
                  ),
                );
              }
              setRemovedProcedureIds([]);
              setRemovedPrescriptionItems([]);
              if (newPrescriptions.length > 0) {
                saveNewPrescriptions();
              } else {
                setIsSaving(false);
                if (flag) {
                  if (filteredList.length === 0) {
                    props.onModalClose({
                      error: "No prescription available to print",
                    });
                  } else {
                    setPrintPrescriptionList([...filteredList]);
                    setpdfscreen(true);
                  }
                } else {
                  props.onModalClose({
                    success: "Prescription updated successfully",
                  });
                }
              }
            }
          }
        }),
      );
    });

  };

  // method to modify cluster
  const modifyCluster = (feildname, filedvalue) => {
    if (feildname == "Advice to dispenser") {
      modifyNotes.advicetoDispenser = filedvalue;
    }
  };

  // method to modify element
  const modifyElement = (feildname, filedvalue) => {
    console.log("feildname,filedvalue", feildname, filedvalue);
    if (feildname == "Local medicinal product brand") {
      modifyNotes.localMedicalBrand = filedvalue;
    } else if (feildname == "Instructions to patient") {
      if (filedvalue === null || filedvalue === "") {
        modifyNotes.instructionstoPatient = "";
      } else {
        modifyNotes.instructionstoPatient = filedvalue;
      }
    } else if (feildname == "Comment") {
      modifyNotes.comments = filedvalue;
    } else if (feildname == "Dose unit") {
      modifyNotes.dose = filedvalue;
    }
  };

  // method to save the data
  const onFormChange = (
    data,
    flag,
    onSaveComplete,
    productId,
    prescriptionCalculation,
  ) => {
    console.log("---Form changed---", data);
    console.log("---patientEhrid---", patientEhrid);
    let notesDetails = " ";
    notesDetails =
      modifyNotes.localMedicalBrand +
      " " +
      " " +
      " " +
      modifyNotes.dose +
      " " +
      modifyNotes.advicetoDispenser +
      " " +
      modifyNotes.instructionstoPatient;
    console.log("prescriptionDetails", notesDetails);
    // ✅ pass batchId in procedure so backend reads it
    let procedure = props.selectedProcedure
      ? {
        ...props.selectedProcedure,
        batchId: data.batchId,
        productId,
        ...prescriptionCalculation,
      }
      : { batchId: data.batchId, productId, ...prescriptionCalculation };
    dispatch(
      ehrActions.saveComposition(
        data,
        patientId,
        visitId,
        EPRESCRIPTION,
        patientEhrid,
        notesDetails,
        procedure,
        (resCb) => {
          const saveSucceeded = Boolean(
            resCb &&
            typeof resCb === "object" &&
            resCb.successMessages?.length &&
            !resCb.errorMessages?.length,
          );
          if (resCb) {
            console.log("Diagnosis Master API Response:", resCb);
            console.log("forjjfnjgjgi", flag, print);
            if (flag) {
              console.log("its print");
              if (resCb.successMessages) {
                let proList = resCb.procedureList;
                console.log("proList : ", proList, proList.length);
                proList.forEach((element) => {
                  filteredList.push(element);
                  count++;
                });
                console.log(
                  "count is : ",
                  count,
                  " : list is : ",
                  filteredList,
                );
              } else {
                if (resCb.errorMessages) {
                  props.onModalClose({ error: resCb.errorMessages[0] });
                }
              }
            } else {
              console.log("its not print");
              if (resCb.successMessages) {
                props.onModalClose({ success: resCb.successMessages[0] });
              } else {
                if (resCb.errorMessages) {
                  props.onModalClose({ error: resCb.errorMessages[0] });
                }
              }
            }
            setIsSaving(false);
          }
          if (onSaveComplete) {
            onSaveComplete(saveSucceeded, resCb);
          }
        },
      ),
    );
  };

  //method to convert schema to json
  const onConvertSchematoJsonprescription = (data, flag) => {
    console.log("schemajson : ", schemajson);
    console.log("jsonconvert:", data);
    console.log("schema :", schemajson);
    //batchId 
   // const batchId = "PRESC_" + Math.random().toString(36).substring(2, 10).toUpperCase();
   const batchId = "PRESC_" + Date.now();
    console.log("batchId generated:", batchId);

    const newPrescriptions = selectedData.filter(
      (prescription) => prescription?.status?.value !== "old",
    );
    let completedPrescriptionSaves = 0;
    let prescriptionSaveFailed = false;
    let prescriptionErpSaveNeeded = true;
    const savedProceduresForPrint = [];

    const syncNewPrescriptionBatchToErp = () => {
      const productListForErp = newPrescriptions.map((prescription) => {
        return {
          product: String(prescription.id),
          weightage: prescription?.dose?.value,
          consumption: prescription?.consumption?.value,
          duration: prescription?.advice?.value,
          durationUnit: prescription?.durationUnit?.value || "days",
          comments: prescription?.comments?.value || "",
        };
      });

      const erpPrescription = {
        cartNo: String(allVisitdates?.phno ?? "").trim(),
        patientId,
        visitId,
        productList: productListForErp,
      };

      dispatch(
        ehrActions.syncPrescriptionToErp(erpPrescription, (erpResponse) => {
          if (erpResponse?.warningMessages?.length) {
            console.warn(erpResponse.warningMessages[0]);
          } else {
            console.log("ERP prescription response:", erpResponse);
          }
        }),
      );
    };

    const onPrescriptionSaveComplete = (saveSucceeded, saveResponse) => {
      completedPrescriptionSaves += 1;
      if (!saveSucceeded) {
        prescriptionSaveFailed = true;
      }
      if (saveSucceeded && Array.isArray(saveResponse?.procedureList)) {
        savedProceduresForPrint.push(...saveResponse.procedureList);
      }
      if (saveResponse?.prescriptionErpSaveNeeded !== true) {
        prescriptionErpSaveNeeded = false;
      }

      if (completedPrescriptionSaves === newPrescriptions.length) {
        if (!prescriptionSaveFailed && prescriptionErpSaveNeeded) {
          syncNewPrescriptionBatchToErp();
        }

        if (flag && !prescriptionSaveFailed) {
          // Print only after every save response has arrived. The earlier
          // fixed three-second delay could run before the procedure save did.
          const prescriptionsToPrint = [
            ...filteredList,
            ...savedProceduresForPrint,
          ].filter(
            (procedure, index, procedures) =>
              procedures.findIndex((item) => item.id === procedure.id) === index,
          );
          setPrintPrescriptionList(prescriptionsToPrint);
          setpdfscreen(true);
        }
      }
    };

    selectedData.forEach((element) => {
      console.log("element : ", element);
      if (element?.status?.value !== "old") {
        for (let content of schemajson.content) {
          for (let events of content.activities) {
            for (let items of events.description.items) {
              console.log("itms", items);
              if (items._type == "CLUSTER") {
                for (let item of items.items) {
                  if (item._type === "CLUSTER") {
                    for (let i of item.items) {
                      console.log("i: ", i);
                      let elementName1 = i.name.value;
                      i.value.value = element["dose"].value;
                      console.log("item value : ", i.name.value, i.value.value);
                      modifyElement(elementName1, i.value.value);
                    }
                  } else {
                    console.log(
                      "field",
                      item.name.value,
                      data[item.name.value],
                    );
                    item.value.value = element["advice"].value;
                    modifyCluster(item.name.value, item.value.value);
                    console.log(
                      "data of advice to dispencer after",
                      item.name.value,
                      data[item.name.value],
                    );
                  }
                }
              }
              if (items._type == "ELEMENT") {
                console.log("element is", items._type);
                if (items.name.value == "Local medicinal product brand") {
                  console.log("item value : ", items.name.value);
                  items.value.value = element["text"];
                  modifyElement(items.name.value, items.value.value);
                } else if (items.name.value == "Instructions to patient") {
                  items.value.value = element["consumption"].value;
                  modifyElement(items.name.value, items.value.value);
                  console.log("data: ", items.value.value);
                } else {
                  items.value.value = element["comments"].value;
                  modifyElement(items.name.value, items.value.value);
                  console.log("data: ", items.value.value);
                }
              }
            }
          }
        }
        console.log("onformchangeschemajson", schemajson);
        console.log("modifynote : ", modifyNotes, print);
        schemajson.batchId = batchId; // attach same batchId to every medicine

        onFormChange(
          schemajson,
          flag,
          onPrescriptionSaveComplete,
          String(element.id),
          {
            weightage: element?.dose?.value,
            consumption: element?.consumption?.value,
            duration: element?.advice?.value,
            durationUnit: element?.durationUnit?.value || "days",
          },
        );
      }
    });
  };

  // method to save and print
  const openPdfModal = (type) => {
    console.log("print is set to : ", print);
    setPrintPreviewType(type);
    handleSubmit(true);
  };

  const openLastVisitPrescrition = () => {
    let proc = [];
    setSelectedData([...proc]);
    setFilteredList([...proc]);
    setProcedureList([...proc]);
    setClonepresclicked(true);
    let vid;
    let curVisitId = 0;
    let visitidList = [];
    for (let i = 0; i < allVisitdates.visitList.length; i++) {
      let visit = allVisitdates.visitList[i];
      console.log("allVisitdates", visit, allVisitdates);
      if (visit.status == "close") {
        console.log("visit.id", visit.id);
        vid = visit.id;
        visitidList.push(visit.id);
        setGetVisitId(visit.id);
      }
    }
    visitidList.reverse();
    // visitidList.forEach((element)=>{
    //   console.log("visitIdList:",element);
    //   let result
    //   // getProcedureListPresc(patientId, element, curVisitId);
    //   if(result == true){
    //     break
    //   }
    // })
    for (let index = 0; index < visitidList.length; index++) {
      const element = visitidList[index];
      let result = getProcedureListPresc(patientId, element, curVisitId);
      if (result == true) {
        break;
      }
    }
    console.log("visitIdList:", visitidList);
    setGetLastVisitId(true);
  };

  {
    /* method for up - down arrow handling for search tablet dropdown */
  }
  const handleKeyDownTab = (event) => {
    if (selectedresult.length === 0) return;

    if (event.key === "ArrowDown") {
      setSelectedIndex((prev) =>
        prev < selectedresult.length - 1 ? prev + 1 : prev,
      );
    } else if (event.key === "ArrowUp") {
      setSelectedIndex((prev) => (prev > 0 ? prev - 1 : 0));
    } else if (event.key === "Enter" && selectedIndex !== -1) {
      handleSelect(selectedresult[selectedIndex]);
      setHideDropdown(true);
      setSelectedIndex(-1);
    }
  };

  // {/*  suggestions/Recomendation changes*/ }
  // const fetchSuggestions = () => {
  //   console.log("Inside the suggestion");

  //   try {
  //     dispatch(
  //       ehrActions.getSuggestionById(56202, 3006, (resCb) => {
  //         try {
  //           if (resCb?.suggestions && Array.isArray(resCb.suggestions)) {
  //             console.log("suggestion-resp", resCb.suggestions);

  //             // Loop through all suggestions
  //             resCb.suggestions.forEach((suggestion) => {
  //               if (suggestion?.content?.[0]?.activities) {
  //                 let val = suggestion.content[0].activities[0]?.description?.items || [];
  //                 console.log("suggestion-resp", val);

  //                 // Handle suggestion-specific data
  //                 handleSuggestionData(val);
  //               } else {
  //                 console.warn("No valid suggestions found:", suggestion?.error);
  //               }
  //             });
  //           } else {
  //             console.warn("Invalid response format:", resCb);
  //             setSuggestions("");
  //           }
  //         } catch (innerError) {
  //           console.error("Error processing response:", innerError);
  //           setSuggestions("");
  //         }
  //       })
  //     );
  //   } catch (error) {
  //     console.error("Error fetching suggestions:", error);
  //   }
  // };

  // const handleSuggestionData = (data) => {
  //   let dose = "";
  //   let consumption = "";
  //   let advice = "";
  //   let comments = "";
  //   let text = "";
  //   let id = "";
  //   let productsearch = "";

  //   if (data) {
  //     console.log("prescription data : ", data);
  //     let val = data;
  //     for (let items of val) {
  //       if (items._type == "CLUSTER") {
  //         for (let item of items.items) {
  //           if (item._type === "CLUSTER") {
  //             for (let i of item.items) {
  //               dose = i.value?.value || "";
  //             }
  //           } else {
  //             advice = item.value?.value || "";
  //           }
  //         }
  //       }
  //       if (items._type == "ELEMENT") {
  //         if (items.name?.value == "Local medicinal product brand") {
  //           text = items.value?.value || "";
  //         } else if (items.name?.value == "Instructions to patient") {
  //           consumption = items.value?.value || "";
  //         } else {
  //           comments = items.value?.value || "";
  //         }
  //       }
  //     }

  //     productsearch = text || "dol";

  //     // Fetch product details only after processing suggestion data
  //     dispatch(
  //       doctorActions.getProductDetails(
  //         productsearch,
  //         PRODUCT_PHARMACY_LOCATION,
  //         (productResponse) => {
  //           if (productResponse?.erpProductList?.length > 0) {
  //             console.log("Product inside is", productResponse.erpProductList);
  //             let productList = productResponse.erpProductList;

  //             if (productList[0]?.productId) {
  //               id = productList[0].productId;
  //               const newData = {
  //                 id,
  //                 text,
  //                 dose,
  //                 consumption,
  //                 advice,
  //                 comments,
  //               };

  //               console.log("newData", newData);
  //               handleSuggestionAdd(newData, true);
  //             }
  //           } else {
  //             console.log("Product ID is null or product list is empty");
  //           }
  //         }
  //       )
  //     );
  //   }
  // };

  // const handleSuggestionAdd = (result, isFromSuggestion = false) => {
  //   console.log("result : ", result, selectedData);

  //   // Create a deep copy of the result object to avoid reference issues
  //   const newData = JSON.parse(
  //     JSON.stringify({
  //       id: result.id,
  //       text: result.text,
  //       dose: { label: "Dose", value: result.dose },
  //       consumption: { label: "Consumption", value: result.consumption },
  //       advice: { label: "Advice", value: result.advice },
  //       comments: { label: "Comments", value: result.comments },
  //     })
  //   );

  //   if (result.dose || result.consumption || result.advice || result.comments) {
  //     if (!isFromSuggestion) {
  //       setSelectedData((prev) => [...prev, newData]);
  //     } else {
  //       setSuggestions((prev) => [...prev, newData]);
  //     }
  //   }
  // };

  // const [searchTerm, setSearchTerm] = useState('');
  // const [showSearchBox, setShowSearchBox] = useState(false);
  // const [filteredSuggestions, setFilteredSuggestions] = useState(suggestions || []);

  // useEffect(() => {
  //   if (!searchTerm) {
  //     setFilteredSuggestions(suggestions); // Reset when search is cleared
  //   } else {
  //     const filtered = suggestions.filter((suggestion) =>
  //       suggestion.text.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //     setFilteredSuggestions(filtered);
  //   }
  // }, [searchTerm, suggestions]);

  // const handleSearchClick = () => {
  //   setShowSearchBox(!showSearchBox);
  // };

  // const handleSearchChange = (e) => {
  //   const value = e.target.value;
  //   setSearchTerm(value);

  //   if (value === '') {
  //     setFilteredSuggestions(suggestions); // Reset to original suggestions when cleared
  //   } else {
  //     const filtered = suggestions.filter((s) =>
  //       s.text.toLowerCase().includes(value.toLowerCase())
  //     );
  //     setFilteredSuggestions(filtered);
  //   }
  // };

  // const handleSearchSubmit = (e) => {
  //   if (e.key === 'Enter') {
  //     e.preventDefault();
  //     if (searchTerm.trim() !== '') {
  //       const filtered = suggestions.filter((s) =>
  //         s.text.toLowerCase().includes(searchTerm.toLowerCase())
  //       );
  //       setFilteredSuggestions(filtered);
  //     }
  //   }
  // };

  const handleSelect = (result) => {
    console.log("Selected:", result);
    setSearchResults([result]);
    setHideResults(false);
    console.log("before search results in handleseletct:", searchResults);
    console.log("search results in handleseletct:", searchResults);
    // setSelectedresult(result);
    console.log("Selected:", selectedresult);
  };

  const activePrescriptionList = () => {
    console.log("Active prescription clicked");
    let proc = [];
    if (clonepresclicked) {
      setSelectedData([...proc]);
      setFilteredList([...proc]);
      setProcedureList([...proc]);
      setClonepresclicked(false);
    }
    setRemovedProcedureIds([]);
    getProcedureListPresc(patientId, visitId, 0, "old");
    setHideResults(false);
  };

  return (
    <>
      <div className="w-100 flex-wrap flex-column border rounded pt-1 p-3 align-items-center">
        <div className="prescription-container mb-1">
          {/* {getVisitId !== 0  && (
      <button
      type="submit"
      className="btn-primary p-2 border rounded col-2 my-2"
      style={{ float: "right", width: "fit-content", whiteSpace: "nowrap" }}
      onClick={(e) => {
        openLastVisitPrescrition();
      }}
    >
      Clone-Prescription
    </button>
          )} */}
          {props.mode === "new" && (
            <Tabs
              value={tabValue}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              className="mt-n2"
              style={{ minHeight: "30px", maxHeight: "30px" }}
            >
              <Tab
                style={{ minHeight: "30px", maxHeight: "30px" }}
                label="ALL"
              />
              <Tab
                style={{ minHeight: "30px", maxHeight: "30px" }}
                label="FAV"
              />
            </Tabs>
          )}
          {tabValue === 0 && (
            <div className="mt-2">
              {props.mode == "new" && (
                <div className="d-flex align-items-center searchbox my-2 position-relative gap-2">
                  {/* Search Input */}
                  <input
                    type="text"
                    ref={searchInputRef}
                    placeholder="Search..."
                    value={searchQuery}
                    className="border rounded flex-fill p-2"
                    onChange={handleSearchInputChange}
                    onKeyDown={handleKeyDownTab}
                  />
                  {/* Search Button */}
                  <Tooltip
                    title="Search"
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        backgroundColor: "white",
                        color: "black",
                        boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
                        fontSize: "14px",
                      },
                    }}
                  >
                    <Fab
                      size="small"
                      className="ml-3 bg-primary text-white"
                      aria-label="search"
                      variant="extended"
                      onClick={() => handleSearch()}
                    >
                      <Search />
                    </Fab>
                  </Tooltip>

                  <Tooltip
                    title="Active prescription"
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        backgroundColor: "white",
                        color: "black",
                        boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
                        fontSize: "14px",
                      },
                    }}
                  >
                    <Fab
                      size="small"
                      className="ml-3 bg-primary text-white"
                      aria-label="search"
                      variant="extended"
                      onClick={() => activePrescriptionList()}
                    >
                      <PublishedWithChanges />
                    </Fab>
                  </Tooltip>

                  {/* Clone Prescription Button */}
                  {getVisitId !== 0 && (
                    <Tooltip
                      title="Repeat"
                      sx={{
                        "& .MuiTooltip-tooltip": {
                          backgroundColor: "white",
                          color: "black",
                          boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
                          fontSize: "14px",
                        },
                      }}
                    >
                      <Fab
                        className="ml-3 bg-primary text-white"
                        aria-label="repeat"
                        size="small"
                        variant="extended"
                        onClick={(e) => {
                          openLastVisitPrescrition();
                        }}
                      >
                        <ReplayIcon fontSize="medium" />
                      </Fab>
                    </Tooltip>
                  )}

                  {/* Dropdown for Search Results */}
                  {hideDropdown !== true && selectedresult.length > 0 && (
                    <div
                      className="search-results-dropdown position-absolute bg-white border rounded mt-1"
                      style={{
                        width: "100%",
                        top: "100%",
                        left: 0,
                        zIndex: 1000,
                      }}
                    >
                      {selectedresult.map((result, index) => (
                        <div
                          key={result.id}
                          className={`p-2 presc-search-result ${index === selectedIndex ? "selected" : ""
                            }`}
                          onClick={() => {
                            handleSelect(result);
                            setHideDropdown(true);
                            setSelectedIndex(-1);
                          }}
                        >
                          <strong style={{ fontSize: "16px" }}>
                            {result.text}
                          </strong>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {hideResults != true &&
                searchResults.map((result) => (
                  <div
                    key={result.id}
                    className="d-flex flex-column p-2 border rounded w-100 presc-search-result bg-white mb-2"
                  >
                    {/* Tablet Name */}
                    <div className="mb-2">
                      <strong style={{ fontSize: "16px" }}>
                        {result.text}
                      </strong>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      {/* Image */}
                      <div
                        className="d-flex align-items-center justify-content-center mr-2"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          overflow: "hidden",
                          border: "1px solid #ccc",
                        }}
                      >
                        <img
                          src="https://tse4.mm.bing.net/th?id=OIP._FRJCbrjh93KCZTzNVyP3AHaE8&pid=Api&P=0&h=180"
                          alt="Item"
                          className="w-100 h-100"
                          style={{ objectFit: "cover" }}
                        />
                      </div>

                      {/* Prescription Fields */}
                      <div className="d-flex flex-fill align-items-center gap-3">
                        {/* Dose */}
                        <TextField
                          label="Weightage"
                          variant="outlined"
                          size="small"
                          style={{ width: "150px" }}
                          value={result.dose}
                          onChange={(e) =>
                            handleDoseChange(result.id, e.target.value)
                          }
                          disabled={isReadonly}
                          InputProps={{
                            style: { height: "36px", fontSize: "14px" },
                          }}
                        />

                        {/* Consumption */}
                        <Autocomplete
                          freeSolo
                          options={dataDrop}
                          value={result.consumption}
                          disabled={isReadonly}
                          onChange={(e, value) =>
                            handleConsumptionChangePresc(result, value)
                          }
                          onInputChange={(e, value) =>
                            handleConsumptionChangePresc(result, value)
                          }
                          sx={{
                            width: 150,
                            "& .MuiAutocomplete-inputRoot": {
                              flexWrap: "nowrap", // 👈 KEY FIX
                            },
                            "& .MuiAutocomplete-input": {
                              whiteSpace: "nowrap", // 👈 text stays in one line
                              textOverflow: "ellipsis",
                            },
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Consumption"
                              variant="outlined"
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                style: {
                                  height: "36px",
                                  fontSize: "14px",
                                },
                              }}
                            />
                          )}
                        />

                        {/* Duration */}
                        <TextField
                          label="Duration"
                          variant="outlined"
                          size="small"
                          style={{ width: "232px" }}
                          value={result.advice}
                          onChange={(e) =>
                            handleAdviceChange(result.id, e.target.value)
                          }
                          disabled={isReadonly}
                          InputProps={{
                            style: { height: "36px", fontSize: "14px" },
                            endAdornment: (
                              <Select
                                aria-label="Duration unit"
                                value={result.durationUnit || "days"}
                                onChange={(e) =>
                                  handleDurationUnitChange(result.id, e.target.value)
                                }
                                disabled={isReadonly}
                                variant="standard"
                                disableUnderline
                                sx={{
                                  minWidth: 124,
                                  flexShrink: 0,
                                  marginRight: "-10px",
                                  cursor: isReadonly ? "default" : "pointer",
                                  "& .MuiSelect-select": {
                                    fontSize: "14px",
                                    fontFamily: "inherit",
                                    padding: "4px 24px 4px 8px",
                                  },
                                  "& .MuiSelect-icon": {
                                    color: "#757575",
                                    right: 0,
                                  },
                                }}
                              >
                                <MenuItem value="days">Days</MenuItem>
                                <MenuItem value="months">Months</MenuItem>
                                <MenuItem value="years">Years</MenuItem>
                              </Select>
                            ),
                          }}
                        />

                        {/* Comments */}
                        <TextField
                          label="Comments"
                          variant="outlined"
                          size="small"
                          style={{ width: "250px" }}
                          value={result.comments}
                          onChange={(e) =>
                            handleCommentsChange(result.id, e.target.value)
                          }
                          disabled={isReadonly}
                          InputProps={{
                            style: { height: "36px", fontSize: "14px" },
                          }}
                        />
                      </div>
                      {/* Add Button */}
                      {props.mode === "new" && (
                        <IconButton
                          onClick={() => handleAdd(result)}
                          size="small"
                          style={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            marginLeft: "8px",
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                          }}
                        >
                          <Add fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          )}
          {tabValue === 1 && <div>Your favourites will be here soon...</div>}

          {tabValue === 0 &&
            // (selectedData.length > 0 || getLastVisitId === true || suggestions?.length > 0) &&
            (selectedData.length > 0 ||
              removedProcedureIds.length > 0 ||
              getLastVisitId === true) &&
            props.mode === "new" && (
              <div className="text-left w-100 d-flex flex-column flex-md-row gap-2">
                {/* Selected Data */}
                {/* <div
                  className={`flex-grow-1 ${!suggestions?.length ? "w-100" : ""}`}
                  style={{
                    minWidth: "300px",
                    maxWidth: "95%",
                  }}
                > */}
                <div
                  className={`flex-grow-1 w-100`}
                  style={{
                    minWidth: "300px",
                    maxWidth: "95%",
                  }}
                >
                  <label>
                    <b>Prescription Selected</b>
                  </label>

                  {selectedData.length > 0 ? (
                    selectedData.map((selected, index) => (
                      <div
                        className="tablet-container"
                        onClick={() => handleSelectedItemClick(selected)}
                      >
                        {/* Tablet Image */}
                        <div className="tablet-image-wrapper">
                          <img
                            src="https://tse4.mm.bing.net/th?id=OIP._FRJCbrjh93KCZTzNVyP3AHaE8&pid=Api&P=0&h=180"
                            alt="Tablet"
                            className="tablet-image"
                          />
                        </div>

                        {/* Tablet Name */}
                        <div
                          className="tablet-name"
                          title={selected.text}
                          style={{ fontWeight: "normal" }}
                        >
                          {selected.text}
                        </div>

                        {/* Tablet Details */}
                        <div className="tablet-details">
                          {Object.keys(selected).map(
                            (label, index) =>
                              typeof selected[label] === "object" &&
                              selected[label].value &&
                              selected[label].label !== "Status" &&
                              selected[label].label !== "ProcedureID" && (
                                <span
                                  key={index}
                                  className="tablet-detail-field"
                                  title={selected[label].value}
                                >
                                  {selected[label].value}
                                </span>
                              ),
                          )}
                        </div>

                        {/* Remove Button */}
                        <button
                          className="remove-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            // handleCancel(selectedData.length - 1 - index);
                            handleCancel(index);
                          }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted mt-2">No prescriptions selected</p>
                  )}
                  {/* Buttons - Show only when there’s data */}
                  {(selectedData.length > 0 ||
                    removedProcedureIds.length > 0) && (
                    //     <div className="d-flex flex-row-reverse p-3 w-100">
                    //       <button
                    //         type="button"
                    //         className="action-button"
                    //         onClick={(e) => handleSubmit()}
                    //       >
                    //         Save
                    //       </button>
                    //       <button
                    //         type="button"
                    //         className="action-button"
                    //         onClick={(e) => openPdfModal(PRINT_FILE)}
                    //       >
                    //         Print
                    //       </button>

                    //       <button
                    //         type="button"
                    //         className="action-button"
                    //         onClick={(e) => openPdfModal(PRINT_PREVIEW)}
                    //         onKeyDown={(e) => {
                    //           if (e.key === "Tab" && !e.shiftKey) {
                    //             e.preventDefault();
                    //             if (searchInputRef.current) {
                    //               searchInputRef.current.focus();
                    //             }
                    //           }
                    //         }}
                    //       >
                    //         Preview
                    //       </button>
                    //     </div>
                    //   )}
                    // </div>
                    <div className="d-flex flex-row-reverse p-3 w-100">
                      <button
                        type="button"
                        className="action-button"
                        disabled={isSaving}
                        onClick={() => handleSubmit()}
                      >
                        {isSaving ? "Saving..." : "Save"}
                      </button>

                      <button
                        type="button"
                        className="action-button"
                        disabled={isSaving}
                        onClick={() => openPdfModal(PRINT_FILE)}
                      >
                        Print
                      </button>

                      <button
                        type="button"
                        className="action-button"
                        disabled={isSaving}
                        onClick={() => openPdfModal(PRINT_PREVIEW)}
                      >
                        Preview
                      </button>
                    </div>
                  )}
                </div>

                {/* Suggestions Section - Hide if Empty 
                {suggestions?.length > 0 && (
                  <div style={{ width: "35%", minWidth: "280px" }}>
                    <div className="text-left d-flex flex-column gap-2">
                      <label className="d-flex align-items-center">
                        <b>Recommendations</b>
                        <span
                          style={{ marginLeft: "8px", cursor: "pointer" }}
                          onClick={handleSearchClick}
                        >
                          <SearchIcon fontSize="small" />
                        </span>
                      </label>

                      {/* Search Box 
                      {showSearchBox && (
                        <div className="w-100">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search tablet..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                          />
                        </div>
                      )}

                      {/* Suggestions List
                      {filteredSuggestions?.length > 0 ? (
                        <div>
                          {filteredSuggestions.map((suggestion, index) => (
                            <div
                              key={index}
                              className="recommended-tablet-box border rounded p-2 m-1"
                              style={{
                                alignItems: "flex-start",
                                cursor: "pointer",
                                backgroundColor: "#f9f9f9",
                              }}
                              onClick={() => handleSelectedItemClick(suggestion)}
                            >
                              <div style={{ flexGrow: 1, fontWeight: "bold" }}>
                                {suggestion.text}
                              </div>
                              <div
                                style={{
                                  fontSize: "0.9rem",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                {suggestion.dose?.value && <span>{suggestion.dose.value}</span>}
                                {suggestion.consumption?.value && (
                                  <span>{suggestion.consumption.value}</span>
                                )}

                                {/* Add Button 
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "1.5rem",
                                    cursor: "pointer",
                                    marginLeft: "auto",
                                  }}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="text-muted mt-2">No recommendations available</p>
                      )}
                    </div>
                  </div>
                )}*/}
              </div>
            )}
        </div>
      </div>

      {showpdfscreen ? (
        <div className="">
          <Components.pdfprint
            doctorInfo={""}
            prescriptionList={printPrescriptionList}
            presc={props.form}
            ehrid={patientEhrid}
            selectedPatient={props.patientInfo}
            printPreviewType={printPreviewType}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
export default Prescription;
